import { useQuery } from 'react-query'
import { TimeZones } from '../../types'
import { logFactory } from '../../util/logFactory'
import { useAppointmentsService } from '../services'

interface UseTimeZonesContext {
  timeZones?: TimeZones
  isError: boolean
  isLoading: boolean
}

interface UseTimeZonesProps {
  country?: string
  search?: string
}

const hookName = 'useTimeZones'
const log = logFactory(hookName)

const useTimeZones = ({ country, search }: UseTimeZonesProps = {}): UseTimeZonesContext => {
  const params = {
    country_code: country,
    search,
  }

  const { getTimeZones, isReady } = useAppointmentsService()

  const fetchTimeZones = async (): Promise<TimeZones> => {
    log(`🗺️ Fetching time zones...`, params)

    const found = await getTimeZones(params)

    log(`🗺️ Found time zones`, found)

    return found
  }

  const isQueryEnabled = Boolean(isReady)

  const {
    data: timeZones,
    isError,
    isLoading,
  } = useQuery([hookName, params], fetchTimeZones, {
    enabled: isQueryEnabled,
  })

  return {
    timeZones,
    isError,
    isLoading: (!isReady || isLoading) && !timeZones,
  }
}

export { useTimeZones }
